export const locale = {
    lang: 'es',
    data: {
      'WIZARD': {
        'TESTTITULO': 'TITULO DEL WIZARD :V',
        'CARGANDO': 'Cargando productos adquiridos.',
        'SINPRODS': 'No ha adquirido este producto.',
        'LANDING': {
          'PRODUCTO': {
            'IZZI':{
              'TITULO': 'BIENVENIDO A IZZI',
              'CURRENT': 'Este es el proceso actual de izzi',
              'FINISHED': 'Este es un proceso de izzi concluído.',
              'RESULTS': {
                'CURRENT': 'Proceso de izzi no terminado',
                'FINISHED': 'Este es el proceso actual de izzi'
              }
            }
          },
          'DONE': 'Año de aplicación: ',
          'LEGA': 'Resultados heredados',
          'FOCUS': 'ENCUESTAS DE  FOCUS AREA',
          'ENTRAR': 'Iniciar'
        },
        'STEPSTAT': {
          'LOCK': 'Paso bloqueado',
          'PEND': 'Paso abierto',
          'COMP': 'Paso completado'
        },
        'NOPRODUCTS': {
          'TITULO': 'Su empresa no cuenta con productos adquiridos.',
          'SUBTI': 'Información sobre la oferta.'
        },
        'IZZI': {
          'TITULO': 'Izzi',
          'STEPS': {
            'STP1': {
              'WIZBT': 'Idiomas',
              'TITULO': 'Idiomas',
              'SUBTI': 'Selección de idiomas'
            },
            'STP_NPS': {
              'WIZBT': 'NPS',
              'TITULO': 'NPS',
              'SUBTI': 'Edición de NPS'
            },
            'STP1-1': {
              'WIZBT': 'Reactivos',
              'TITULO': 'Reactivos',
              'SUBTI': 'Selección de reactivos'
            },
            'STP2': {
              'WIZBT': 'Prácticas culturales',
              'TITULO': 'Prácticas culturales',
              'SUBTI': 'Evaluación de prácticas culturales (EPC)'
            },
            'STP_CONTROL': {
              'WIZBT': 'Pregunta de control',
              'TITULO': 'Pregunta de control',
              'SUBTI': 'Edición de la pregunta de control'
            },
            'STP3': {
              'WIZBT': 'Demográficos',
              'TITULO': 'Demográficos',
              'SUBTI': 'Ingrese la información de los demográficos a emplear en la encuesta. NOTA: Los demográficos en color amarillo son opcionales'
            },
            'STP3-1': {
              'WIZBT': 'Preguntas abiertas',
              'TITULO': 'Preguntas abiertas',
              'SUBTI': 'Ingrese las preguntas abiertas'
            },
            'STP4': {
              'WIZBT': 'Adicionales',
              'TITULO': 'Adicionales',
              'SUBTI': 'Introducción de preguntas adicionales'
            },
            'STP4-1': {
              'WIZBT': 'Generar encuesta',
              'TITULO': 'Generar encuesta',
              'SUBTI': 'Genera la encuesta',
              'WIZBT2': 'Encuesta',
              'TITULO2': 'Encuesta',
            },
            'STP5': {
              'WIZBT': 'Colaboradores',
              'TITULO': 'Colaboradores',
              'SUBTI': 'Carga de lista de colaboradores'
            },
            'STP6': {
              'WIZBT': 'Programar encuesta',
              'TITULO': 'Programar encuesta',
              'SUBTI': 'Programe la fecha de lanzamiento y recordatorios de la encuesta'
            },
            'STP7': {
              'WIZBT': 'Envío de correos',
              'TITULO': 'Envío de correos',
              'SUBTI': 'Realice el envío a sus colaboradores de la invitación para realizar la encuesta'
            },
            'STP8': {
              'WIZBT': 'Cierre de encuesta',
              'TITULO': 'Cierre de encuesta',
              'SUBTI': 'Avances antes del cierre de la encuesta'
            }
          }
        }
      }
    }
};
